import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { notifySuccess } from "src/components/Common/Toast";
import { useApiError } from "../../useApiError";
import { passwordInit } from "src/service/papi";
import { useTranslation } from "react-i18next";

interface IUseLogInProps {
  setStateInit: () => void;
}
export function usePasswordInit({ setStateInit }: IUseLogInProps) {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { handleError } = useApiError();
  const { t } = useTranslation();
  const { isLoading, mutateAsync: mutatePasswordInit } = useMutation(
    "passwordInit",
    passwordInit,
    {
      onSuccess: (res) => {
        notifySuccess(t("logIn.resetPassowrd.confirmAlert"));

        setStateInit();
      },
      onError: handleError,
    }
  );

  return { isLoading, mutatePasswordInit };
}
